/**
 * 系统Store的存放目录
 */
import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);

//获取主项目所有模块
const masterModules = {};
(r =>
  r.keys().forEach(key => {
    masterModules[key.match(/\/(.+?)\.js$/)[1]] = r(key).default;
  }))(require.context('./modules', true, /\.js$/));

//为了做模块缓存，kdbbus在主项目中导入
let modules = {
  ...masterModules
};

export default new Vuex.Store({
  actions,
  getters,
  modules,
  plugins: [],
  strict: process.env.NODE_ENV !== 'production'
});
